import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

// Pages (carga diferida: cada visitante descarga solo la pantalla que abre)
const LandingPage = lazy(() => import('@/pages/LandingPage'));
const LoginPage = lazy(() => import('@/pages/LoginPage'));
const SuperAdminDashboard = lazy(() => import('@/pages/SuperAdminDashboard'));
const CompanyDashboard = lazy(() => import('@/pages/CompanyDashboard'));
const CompanySettings = lazy(() => import('@/pages/CompanySettings'));
const DebtorSearch = lazy(() => import('@/pages/DebtorSearch'));
const DebtorDashboard = lazy(() => import('@/pages/DebtorDashboard'));
const PaymentSuccess = lazy(() => import('@/pages/PaymentSuccess'));
const PaymentFailure = lazy(() => import('@/pages/PaymentFailure'));
const PrivacyPolicy = lazy(() => import('@/pages/PrivacyPolicy'));
const TermsConditions = lazy(() => import('@/pages/TermsConditions'));
const Presentacion = lazy(() => import('@/pages/Presentacion'));
import AuthCallback from '@/components/AuthCallback';

function AppRouter() {
  const location = useLocation();
  
  // CRITICAL: Check for session_id during render (not in useEffect)
  // This prevents race conditions with auth checking
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Suspense fallback={<div className="min-h-screen" data-testid="route-loading" />}>
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/superadmin" element={<SuperAdminDashboard />} />
      <Route path="/dashboard" element={<CompanyDashboard />} />
      <Route path="/dashboard/settings" element={<CompanySettings />} />
      <Route path="/debtor/search" element={<DebtorSearch />} />
      <Route path="/debtor/:token" element={<DebtorDashboard />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/failure" element={<PaymentFailure />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsConditions />} />
      <Route path="/presentacion" element={<Presentacion />} />
      
      {/* Rutas personalizadas por empresa */}
      <Route path="/t/:slug/:token" element={<DebtorDashboard />} />
      <Route path="/t/:slug" element={<DebtorSearch />} />
      <Route path="/:slug" element={<DebtorSearch />} />
    </Routes>
    </Suspense>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;